export default "__VITE_ASSET__CMMzXOuF__"